module.exports = __webpack_public_path__ + "static/media/14.cf543337.png";